import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { TextBoxComponent } from "@syncfusion/ej2-react-inputs";
import css from "./index.module.css";
import AttachIssues from "./AttachIssues/AttachIssues";
import AttachFiles from "./AttachFiles/AttachFiles";
import { checkIfFilesAreAttachedForIssues } from "../../services/utils/transmittalHelpers";
import { showToastNotification } from "../../actions/toast";
import { createFileShortcut, consumeExternalFiles } from "../../actions/fileUpload";
import { TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS, TOAST_TYPE_WARNING } from "../../services/constants";
import ButtonComponent from "../../cubeComponent/form/ButtonComponent";
import ModalStateDialogComponent from "../../cubeComponent/html/modal/ModalWithState";
import { BUTTON_TYPES } from "../../cubeComponent/constants/globalVariable";
import _ from "lodash";
import PropTypes from "prop-types";
import FileManager from "./FileManagerNew";
import { Box, CircularProgress } from "@mui/material";
import IconComponent from "@CubeComponents/icons";
import { getBackendUrl } from "../../utils";
import axiosWrapper from "@Services/axiosWrapper";
interface FileManagerAsPopupProps {
  handleFileSelectedButtonClick?: any;
  handleFileSelectedCancelClick?: any;
  handleFolderSelected?: any;
  allowFolderSelectionCallback?: any; // default: false
  workspaceId?: any;
  id?: any;
  openThisSpaceByDefault?: any; // default: false
  wrapperStyles?: any; // default: {}
  hideIssues?: any; // default: false
  hideTasks?: any; // default: false
  hideReviews?: any; // default: false
  hideEstimates?: any; // default: false
  hideExternalSpace?: any; // default: false
  hideClashTests?: any; // default: false
  createShortcut?: any; // default: false
  consumeFiles?: any; // default: false
  hideSchedules?: any; // default: false
  hideContracts?: any; // default: false
  hideMergeFiles?: any; // default: false
  enableOnlyShareableResources?: any; // default: false
  shortCutData?: any; // default: {}
  hideAllTabs?: any; // default: false
  useAttachedExternalVolume?: any; // default: false
  heading?: any;
  allowInput?: any;
  inputLabel?: any;
  isTransmittal?: any;
  externalFolderData?: any;
  disableFiles?: any;
  minimumFiles?: any;
  errorMessage?: any;
  showOnlyMergedFile?: any;
  addEmptyContainerToList?: any;
  enableFilesTypes?: any;
  createMerge?: any; // default: false
  attachSelectedBtnName?: any; // default: null
  selectedFilesData?: any; // default: []
  disableMultipleSelection?: any;
  projectId?: any;
  enableSpaceListDropdown?: any;
  setSpaceId?: any;
  disableContextMenu?: any; // default: false
  setIsLoadingCreateButton?: any;
  isLoadingCreateButton?: any;
  isLoadingAddFiles?: any;
  setIsLoadingAddFiles?: any;
}
function FileManagerAsPopup({
  handleFileSelectedButtonClick,
  handleFileSelectedCancelClick,
  handleFolderSelected,
  allowFolderSelectionCallback = false,
  workspaceId,
  openThisSpaceByDefault = false,
  wrapperStyles = {},
  hideIssues = false,
  hideTasks = false,
  hideReviews = false,
  hideEstimates = false,
  hideExternalSpace = false,
  hideClashTests = false,
  createShortcut = false,
  consumeFiles = false,
  hideSchedules = false,
  hideContracts = false,
  hideMergeFiles = false,
  enableOnlyShareableResources = false,
  shortCutData = {},
  hideAllTabs = false,
  useAttachedExternalVolume = false,
  heading,
  allowInput,
  inputLabel,
  isTransmittal,
  externalFolderData,
  disableFiles,
  minimumFiles,
  errorMessage,
  showOnlyMergedFile,
  addEmptyContainerToList,
  enableFilesTypes,
  createMerge = false,
  attachSelectedBtnName = null,
  selectedFilesData = [],
  disableMultipleSelection,
  projectId,
  enableSpaceListDropdown,
  setSpaceId,
  disableContextMenu = false,
  setIsLoadingCreateButton,
  isLoadingCreateButton,
  isLoadingAddFiles,
  setIsLoadingAddFiles,
}: Readonly<FileManagerAsPopupProps>) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [listOfSelectedFiles, setListOfSelectedFiles] = useState<any>({});
  const [AddToListDisabled, setAddToListDisabled] = useState(true);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const fileManagerHeading = heading || "Attach Files";
  const [inputValue, setInputValue] = useState("");
  const [disableAttachButton, setDisableAttachButton] = useState(false);
  const [openAttachIssuesModal, setOpenAttachIssuesModal] = useState(false);
  const [filesIssues] = useState([]);
  const [issuesHavingNoFiles, setIssuesHavingNoFiles] = useState([]);
  const [selectedFolderData, setSelectedFolderData] = useState<any>({});
  const [disableCreateShortcutButton, setDisableCreateShortcutButton] = useState(true);
  const [newState, setNewState] = useState<any>(false);
  const [submitButtonLoading, setSubmitButtonLoading] = useState(false);
  const [spaceList, setSpaceList] = useState<any[]>([]);
  const [showNoSpaceWarning, setShowNoSpaceWarning] = useState<any>(null);

  const getSpaces = async () => {
    const response: any = await axiosWrapper.post(`${getBackendUrl()}/spaces/spacesData`, {
      value: {
        projectId,
      },
    });
    if (response.data.result) {
      setSpaceList(response.data.result);
      if (!workspaceId && response.data?.result?.length == 0) {
        setShowNoSpaceWarning(true);
      } else {
        setShowNoSpaceWarning(false);
      }
    }
  };

  useEffect(() => {
    let disable = false;
    if (allowInput) {
      disable = disable || !inputValue;
    }
    if (minimumFiles && Object.keys(listOfSelectedFiles).length < minimumFiles) {
      disable = true;
    }
    setDisableAttachButton(disable);

    if (isTransmittal === true && Object.keys(listOfSelectedFiles).length) {
      const issuesWithNoFiles: any = checkIfFilesAreAttachedForIssues(listOfSelectedFiles);
      setIssuesHavingNoFiles(issuesWithNoFiles);
    }
  }, [listOfSelectedFiles, inputValue]);

  useEffect(() => {
    if (disableMultipleSelection) {
      if (selectedFiles.length == 1 && Object.keys(listOfSelectedFiles).length < 1) {
        setAddToListDisabled(false);
      } else {
        setAddToListDisabled(true);
      }
    } else if (selectedFiles.length) {
      setAddToListDisabled(false);
    } else {
      setAddToListDisabled(true);
    }
  }, [selectedFiles, listOfSelectedFiles]);

  useEffect(() => {
    if (enableSpaceListDropdown) {
      getSpaces();
    } else if (workspaceId) {
      setShowNoSpaceWarning(false);
    }
  }, [enableSpaceListDropdown]);

  const handleFileSelectionCallback = (data: any) => {
    if (_.get(data, "[0].resourceType") !== "RESOURCE_TYPE_FOLDER") {
      setSelectedFiles(data);
    }
    if (data.length == 0) {
      setSelectedFiles([]);
    }
  };

  useEffect(() => {
    if (createMerge && selectedFilesData.length) {
      handleAddToSelection(null, selectedFilesData);
    }
  }, [createMerge, selectedFilesData]);

  const handleAddToSelection = (e: any, selectedFilesList?: any) => {
    let selectedFilesCopy;
    if (selectedFilesList) {
      selectedFilesCopy = selectedFilesList;
      setSelectedFiles(selectedFilesList);
    } else {
      selectedFilesCopy = [...selectedFiles];
    }

    const selectedFilesToObj: any = { ...listOfSelectedFiles };

    selectedFilesCopy.forEach((file: any) => {
      if (Object.hasOwn(file, "dev")) {
        selectedFilesToObj[`${file.filterPath}${file.name}`] = file;
      } else if (file.resourceType == "RESOURCE_TYPE_FILE" || file.resourceType == "RESOURCE_TYPE_EMBED") {
        if (file.fileVersion) {
          selectedFilesToObj[file.fileVersion] = file;
        } else if (addEmptyContainerToList) {
          selectedFilesToObj[file.id] = file;
        }
      } else if (file.resourceType == "RESOURCE_TYPE_ISSUE") {
        selectedFilesToObj[file.issueVersionId] = file;
      } else if (file.resourceType == "RESOURCE_TYPE_TASKS") {
        selectedFilesToObj[file.taskId] = file;
      } else if (file.resourceType == "RESOURCE_TYPE_ESTIMATE") {
        selectedFilesToObj[file.id] = file;
      } else if (file.resourceType == "RESOURCE_TYPE_MERGED_FILE") {
        selectedFilesToObj[file.id] = file;
      }
    });
    setListOfSelectedFiles(selectedFilesToObj);
    if (e) {
      e.stopPropagation();
    }
  };

  const handleRemoveOfSelectedFile = (fileData: any) => {
    const tempListOfSelectedFiles: any = { ...listOfSelectedFiles };
    if (fileData.resourceType == "RESOURCE_TYPE_MERGED_FILE" || fileData.resourceType == "RESOURCE_TYPE_ESTIMATE") {
      delete tempListOfSelectedFiles[fileData.id];
    } else {
      delete tempListOfSelectedFiles[fileData.fileVersion];
    }

    if (Object.hasOwn(fileData, "dev")) {
      delete tempListOfSelectedFiles[fileData.name];
    }
    setListOfSelectedFiles(tempListOfSelectedFiles);
  };

  const handleFileSelectedButtonClickCallback = () => {
    if (typeof setIsLoadingCreateButton === "function") {
      setIsLoadingCreateButton(true);
    }
    if (typeof setIsLoadingAddFiles === "function") {
      setIsLoadingAddFiles(true);
    }
    handleFileSelectedButtonClick(listOfSelectedFiles, inputValue);
  };

  const handleFolderSelectedCallback = () => {
    setDisableAttachButton(true);
    handleFolderSelected(selectedFolderData);
  };

  const handleSetOpenAttachIssuesModal = (val: any) => {
    setOpenAttachIssuesModal(val);
  };

  const onAttachIssuesCallback = (data: any) => {
    let filteredFilesIssues: any = [];
    const currentVersion = filesIssues.reduce(
      (acc: any, curr: any) => (acc > curr.fileVersionNumber ? acc : curr.fileVersionNumber),
      0,
    );

    if (data.selectedIssueType.includes("open")) {
      filesIssues.forEach((file: any) => {
        if (file.status.toLowerCase() == "open") {
          filteredFilesIssues.push(file);
        }
      });
    }
    if (data.selectedIssueType.includes("in_review")) {
      filesIssues.forEach((file: any) => {
        if (file.status.toLowerCase() == "in_review") {
          filteredFilesIssues.push(file);
        }
      });
    }
    if (data.selectedIssueType.includes("closed")) {
      filesIssues.forEach((file: any) => {
        if (file.status.toLowerCase() == "closed") {
          filteredFilesIssues.push(file);
        }
      });
    }
    if (data.selectedIssueType.length == 0) {
      filteredFilesIssues = filesIssues;
    }

    if (data.selectedVersionType == "current_version") {
      filteredFilesIssues = filteredFilesIssues.filter((file: any) => file.fileVersionNumber == currentVersion);
    } else if (data.selectedVersionType == "previous_version") {
      filteredFilesIssues = filteredFilesIssues.filter((file: any) => file.fileVersionNumber != currentVersion);
    } else if (data.selectedVersionType == "") {
      filteredFilesIssues = [];
    }

    const selectedFilesToObj: any = { ...listOfSelectedFiles };
    filteredFilesIssues.map((file: any) => {
      selectedFilesToObj[file.issueVersionId] = file;
    });
    setListOfSelectedFiles(selectedFilesToObj);
  };

  const handleCancelClickOnAttachFiles = () => {
    const tempListOfSelectedFiles: any = { ...listOfSelectedFiles };
    issuesHavingNoFiles.forEach((issue: any) => delete tempListOfSelectedFiles[issue.issueVersionId]);
    setListOfSelectedFiles(tempListOfSelectedFiles);
    setIssuesHavingNoFiles([]);
    // e.stopPropagation()
  };

  const handleAcceptClickOnAttachFiles = async (e: any) => {
    const filesUnderWhichIssuesAreCreated: any = {};
    issuesHavingNoFiles.forEach((issues: any) => {
      filesUnderWhichIssuesAreCreated[issues.fileId] = {
        resourceType: "RESOURCE_TYPE_FILE",
        fileVersion: issues.fileId,
        name: issues.fileName,
      };
      if (issues.transmittalVersionId) {
        filesUnderWhichIssuesAreCreated[issues.fileId].transmittalVersionId = issues.transmittalVersionId;
      }
    });
    setListOfSelectedFiles({
      ...listOfSelectedFiles,
      ...filesUnderWhichIssuesAreCreated,
    });
    e.stopPropagation();
  };

  const handleFolderSelectionCallback = (data: any) => {
    setSelectedFolderData(data);
    if (data.folderType == 0) {
      setDisableCreateShortcutButton(false);
    }
  };

  const handleCreateShortcut = async () => {
    setSubmitButtonLoading(true);
    const data = {
      ...shortCutData,
      spaceId: selectedFolderData.spaceId,
      parentId: selectedFolderData.hierarchyId,
      folderType: selectedFolderData.folderType,
    };
    const res = await createFileShortcut(data);
    handleFileSelectedCancelClick();
    if (!res.data.status) {
      dispatch(
        showToastNotification({
          content: res.data.errorMessage,
          type: TOAST_TYPE_ERROR,
        }),
      );
    } else {
      dispatch(
        showToastNotification({
          content: t("Shortcut created successfully"),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
    }
    setSubmitButtonLoading(false);
  };

  const handleConsumeFiles = async () => {
    setSubmitButtonLoading(true);
    const data = {
      fileVersionIds: shortCutData.map((x: any) => ({
        fileVersion: x.fileVersion,
        uploadNewVersion: false,
      })),
      spaceId: selectedFolderData.spaceId,
      parentId: selectedFolderData.hierarchyId,
      folderType: selectedFolderData.folderType,
      skipDuplicateCheck: false,
      transmittalData: externalFolderData,
    };
    const res = await consumeExternalFiles(data);
    if (res.data.status) {
      if (res.data.duplicatesFound) {
        dispatch(
          showToastNotification({
            content: t("Duplicate file(s) found so files were not consumed."),
            type: TOAST_TYPE_ERROR,
          }),
        );
        setNewState({
          response: res.data,
          payload: data,
        });
      } else {
        dispatch(
          showToastNotification({
            content: t("File(s) consumed successfully"),
            type: TOAST_TYPE_SUCCESS,
          }),
        );
      }
    } else if (!res.data.status) {
      if (res.data.errorCode) {
        dispatch(
          showToastNotification({
            content: t("Some Error(s) occured. Please check Escrow files section."),
            type: TOAST_TYPE_WARNING,
          }),
        );
      } else {
        dispatch(
          showToastNotification({
            content: res.data.errorMessage,
            type: TOAST_TYPE_ERROR,
          }),
        );
      }
    }
    setSubmitButtonLoading(false);
    handleFileSelectedCancelClick();
  };

  const handleDuplicateClick = async (button: any) => {
    const newPayload = {
      ...newState.payload,
      skipDuplicateCheck: true,
    };
    newPayload.fileVersionIds = newPayload.fileVersionIds.map((x: any) => ({
      ...x,
      [button]: true,
    }));
    setNewState(false);
    await handleConsumeFiles();
  };

  function footer() {
    return (
      <div className={css.footer}>
        <ButtonComponent
          onClick={() => handleDuplicateClick("uploadNewVersion")}
          buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
        >
          {t("Upload all as new versions")}
        </ButtonComponent>

        <ButtonComponent
          onClick={() => handleDuplicateClick("uploadNewFile")}
          buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
        >
          {t("Upload all as new files")}
        </ButtonComponent>
      </div>
    );
  }

  function modelContent() {
    return (
      <div className="my-5">{`${newState.response.duplicatesFound} files have duplicates at the selected location. How do you want to proceed?`}</div>
    );
  }

  const getContent = () => {
    if (showNoSpaceWarning == null) {
      return (
        <div className="flex justify-center h-full flex-col gap-2 items-center">
          <CircularProgress />
        </div>
      );
    } else if (showNoSpaceWarning) {
      return (
        <div className="flex justify-center h-full flex-col gap-2 items-center">
          <IconComponent name="InspectionFormNoData" />
          {t("No Spaces available in this project")}
        </div>
      );
    } else if (!showNoSpaceWarning) {
      return (
        <>
          <FileManager
            projectId={projectId}
            spaceId={workspaceId}
            fileManagerAsPopup
            openThisSpaceByDefault={openThisSpaceByDefault}
            handleFileSelectionCallback={handleFileSelectionCallback}
            handleFolderSelectionCallback={handleFolderSelectionCallback}
            allowFolderSelectionCallback={allowFolderSelectionCallback}
            hideIssues={hideIssues}
            hideTasks={hideTasks}
            hideReviews={hideReviews}
            hideAllTabs={hideAllTabs}
            hideEstimates={hideEstimates}
            hideSchedules={hideSchedules}
            hideContracts={hideContracts}
            hideMergeFiles={hideMergeFiles}
            hideExternalSpace={hideExternalSpace}
            useAttachedExternalVolume={useAttachedExternalVolume}
            hideClashTests={hideClashTests}
            // enablePersistence={false}
            createShortcut={createShortcut}
            disableFiles={disableFiles}
            enableFilesTypes={enableFilesTypes}
            hideUpload
            showOnlyMergedFile={showOnlyMergedFile}
            alreadySelected={selectedFilesData}
            enableSpaceListDropdown={enableSpaceListDropdown}
            setSpaceId={setSpaceId}
            spaceList={spaceList}
            disableContextMenu={disableContextMenu}
            enableOnlyShareableResources={enableOnlyShareableResources}
          />
          <div className={css.listOfFilesAttached}>
            <div className={css.filesInAttachmentSectionWrapper}>
              {!createShortcut && (
                <div className={`${css.filesInAttachedSection} ${css.removeTopPadding}`}>
                  <div className={css.attachmentLabel} data-testid="listOfFiles">
                    {t("Files")}
                  </div>
                  <div>
                    {Object.keys(listOfSelectedFiles).map((file: any) => {
                      if (
                        [
                          "RESOURCE_TYPE_FILE",
                          "RESOURCE_TYPE_MERGED_FILE",
                          "RESOURCE_TYPE_ESTIMATE",
                          "RESOURCE_TYPE_EMBED",
                        ].includes(listOfSelectedFiles[file].resourceType) ||
                        Object.hasOwn(listOfSelectedFiles[file], "dev")
                      ) {
                        return (
                          <div key={file} className={css.chipWrapper}>
                            <div>{listOfSelectedFiles[file].name}</div>
                            <IconComponent
                              name="cross"
                              onClick={() => handleRemoveOfSelectedFile(listOfSelectedFiles[file])}
                            />
                          </div>
                        );
                      }
                      return null;
                    })}
                  </div>
                </div>
              )}
            </div>
            {!createShortcut && (
              <div className={css.addToListButtonWrapper}>
                <ButtonComponent
                  buttonType="gradientButton"
                  onClick={handleAddToSelection}
                  disabled={AddToListDisabled}
                  data-testid="addFilesToListBtn"
                >
                  {t("Add to list")}
                </ButtonComponent>
              </div>
            )}
          </div>
        </>
      );
    } else return "";
  };
  return (
    <>
      <Box className={css.overlayStyles} onClick={handleFileSelectedCancelClick}>
        {openAttachIssuesModal && (
          <Box
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <AttachIssues
              handleSetOpenAttachIssuesModal={handleSetOpenAttachIssuesModal}
              onSuccess={onAttachIssuesCallback}
            />
          </Box>
        )}
        {issuesHavingNoFiles.length > 0 && (
          <Box
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <AttachFiles
              onCancelClick={handleCancelClickOnAttachFiles}
              onAcceptClick={handleAcceptClickOnAttachFiles}
            />
          </Box>
        )}
        <div className={`${css.fileManagerModalOverlayWrapper} ${wrapperStyles.fileManagerModalOverlayWrapper}`}>
          <Box
            className={css.fileManagerModalWrapper}
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            <div className={css.fileManagerModalHeader}>
              <span>{fileManagerHeading}</span>
            </div>
            {allowInput && (
              <div className={css.inputWrapperRoot}>
                <div className={css.inputWrapper}>
                  <span>{inputLabel}</span>
                  <div className={css.inputBox}>
                    <TextBoxComponent
                      type="text"
                      name="mergedFileName"
                      placeholder={t("Add name here")}
                      value={inputValue}
                      onChange={(e: any) => setInputValue(e.value)}
                    />
                  </div>
                </div>
              </div>
            )}
            {getContent()}
            {errorMessage && (
              <div className={css.errorMessage}>
                <span>{errorMessage}</span>
              </div>
            )}

            <div className={css.fileManagerModalFooter}>
              {!createShortcut && !showNoSpaceWarning && (
                <ButtonComponent
                  buttonType="gradientButton"
                  onClick={handleFolderSelected ? handleFolderSelectedCallback : handleFileSelectedButtonClickCallback}
                  disabled={disableAttachButton}
                  loading={isLoadingCreateButton || isLoadingAddFiles}
                  data-testid="attachSelectedBtn"
                >
                  {attachSelectedBtnName || t("Attach Selected")}
                </ButtonComponent>
              )}
              {createShortcut && !consumeFiles && (
                <ButtonComponent
                  buttonType="gradientButton"
                  onClick={handleCreateShortcut}
                  disabled={disableCreateShortcutButton}
                  data-testid="cancelSelectedFileBtn"
                >
                  {t("Create here")}
                </ButtonComponent>
              )}
              {consumeFiles && (
                <ButtonComponent
                  buttonType="gradientButton"
                  onClick={handleConsumeFiles}
                  loading={submitButtonLoading}
                  disabled={disableCreateShortcutButton}
                >
                  {t("Consume here")}
                </ButtonComponent>
              )}
              <ButtonComponent onClick={handleFileSelectedCancelClick}>{t("Cancel")}</ButtonComponent>
            </div>
          </Box>
        </div>
      </Box>
      {newState && (
        <ModalStateDialogComponent
          headerTitle={t("Duplicates found")}
          footerContent={footer()}
          modelContent={modelContent()}
          isVisible={newState}
          width="40%"
          zIndex={30001}
          onCancel={() => setNewState(false)}
        />
      )}
    </>
  );
}

FileManagerAsPopup.propTypes = {
  handleFileSelectedButtonClick: PropTypes.func.isRequired,
  handleFileSelectedCancelClick: PropTypes.func.isRequired,
  handleFolderSelected: PropTypes.func,
  allowFolderSelectionCallback: PropTypes.bool,
  workspaceId: PropTypes.string,
  openThisSpaceByDefault: PropTypes.bool,
  wrapperStyles: PropTypes.object,
  hideIssues: PropTypes.bool,
  hideTasks: PropTypes.bool,
  hideReviews: PropTypes.bool,
  hideEstimates: PropTypes.bool,
  hideExternalSpace: PropTypes.bool,
  hideClashTests: PropTypes.bool,
  createShortcut: PropTypes.bool,
  consumeFiles: PropTypes.bool,
  hideSchedules: PropTypes.bool,
  hideContracts: PropTypes.bool,
  hideMergeFiles: PropTypes.bool,
  enableOnlyShareableResources: PropTypes.bool,
  shortCutData: PropTypes.object,
  hideAllTabs: PropTypes.bool,
  useAttachedExternalVolume: PropTypes.bool,
  heading: PropTypes.string,
  allowInput: PropTypes.bool,
  inputLabel: PropTypes.string,
  isTransmittal: PropTypes.bool,
  externalFolderData: PropTypes.object,
  disableFiles: PropTypes.bool,
  minimumFiles: PropTypes.number,
  errorMessage: PropTypes.string,
  showOnlyMergedFile: PropTypes.bool,
  addEmptyContainerToList: PropTypes.bool,
  enableFilesTypes: PropTypes.bool,
  createMerge: PropTypes.bool,
  attachSelectedBtnName: PropTypes.string,
  selectedFilesData: PropTypes.array,
  disableMultipleSelection: PropTypes.bool,
  projectId: PropTypes.string,
  enableSpaceListDropdown: PropTypes.bool,
  setSpaceId: PropTypes.func,
  disableContextMenu: PropTypes.bool,
  setIsLoadingCreateButton: PropTypes.func,
  isLoadingCreateButton: PropTypes.bool,
  isLoadingAddFiles: PropTypes.bool,
  setIsLoadingAddFiles: PropTypes.func,
};

export default FileManagerAsPopup;
